var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"justify-center",attrs:{"fluid":"","pa-0":"","fill-height":""}},[_c('Top',{attrs:{"id":"top"}}),_c('Company',{attrs:{"id":"company"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }